module.exports = __webpack_public_path__ + "static/img/electronic-seal.144c895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/electronic-seal.png
// module id = var0
// module chunks = 0